import axios from 'axios';
import { DOH_DNS_SERVERS, DOH_API_ENDPOINTS } from '../config';

export const DNS_RECORD_TYPES = {
  A: 1,
  AAAA: 28,
  CNAME: 5,
  MX: 15,
  TXT: 16,
  NS: 2,
  SOA: 6,
  PTR: 12
};

// DNS 记录类型名称映射
export const DNS_RECORD_TYPE_NAMES = {
  1: 'A',
  28: 'AAAA',
  5: 'CNAME',
  15: 'MX',
  16: 'TXT',
  2: 'NS',
  6: 'SOA',
  12: 'PTR'
};

// DOH DNS 查询函数 (DNS over HTTPS)
export const lookupDnsDOH = async (domain, recordType = 'A', serverKey = 'alibaba', ecsIp = '') => {
  try {
    const dnsServer = DOH_DNS_SERVERS[serverKey] || DOH_DNS_SERVERS.alibaba;
    const apiUrl = DOH_API_ENDPOINTS[serverKey] || DOH_API_ENDPOINTS.alibaba;
    
    // 使用 DNS-over-HTTPS 查询
    // 注意：浏览器环境中直接使用DOH API进行DNS查询
    const params = {
      name: domain,
      type: recordType,
      cd: false // 不进行 DNSSEC 验证
    };
    
    // 添加 ECS IP 地址参数（如果提供）
    if (ecsIp) {
      params.edns_client_subnet = ecsIp;
    }
    
    // 设置 headers
    const headers = {
      'Accept': 'application/dns-json'
    };
    
    const response = await axios.get(apiUrl, {
      params,
      timeout: 10000,
      headers
    });

    // 检查DNS响应状态
    if (response.data.Status === 3) {
      // NXDOMAIN - 域名不存在
      return {
        success: false,
        method: 'DOH',
        server: dnsServer,
        errorCode: 'NXDOMAIN',
        errorMessage: '域名不存在',
        domain: domain // 传递域名给页面层用于国际化
      };
    } else if (response.data.Status !== 0) {
      // 其他错误状态
      return {
        success: false,
        method: 'DOH',
        server: dnsServer,
        errorCode: 'DNS_ERROR',
        errorMessage: `DOH DNS查询失败，状态码: ${response.data.Status}`
      };
    }

    return {
      success: true,
      method: 'DOH',
      server: dnsServer,
      data: {
        question: response.data.Question,
        answers: response.data.Answer || [],
        authority: response.data.Authority || [],
        additional: response.data.Additional || []
      },
      raw: response.data  // 保存原始响应数据
    };
  } catch (error) {
    console.error('DOH DNS查询失败:', error);
    // 根据错误类型返回不同的错误码
    let errorCode = 'GENERAL';
    let errorMessage = 'DOH DNS查询失败';
    
    if (error.code === 'ECONNABORTED') {
      errorCode = 'TIMEOUT';
      errorMessage = '查询超时';
    } else if (error.response) {
      errorCode = 'SERVER_ERROR';
      errorMessage = `服务器错误: ${error.response.status}`;
    } else if (error.request) {
      errorCode = 'NETWORK';
      errorMessage = '网络错误';
    }
    
    return {
      success: false,
      method: 'DOH',
      errorCode,
      errorMessage: error.message || errorMessage
    };
  }
};

// 统一的 DNS 查询函数
export const lookupDns = async (domain, recordType = 'A', queryMethod = 'doh', server = '', ecsIp = '') => {
  // 使用 DOH (DNS over HTTPS) 查询方式
  return await lookupDnsDOH(domain, recordType, server, ecsIp);
};

export const formatDnsRecord = (record) => {
  const { name, type, TTL, data } = record;
  const typeName = DNS_RECORD_TYPE_NAMES[type] || type;
  
  return {
    name,
    type: typeName,
    ttl: TTL,
    data
  };
};

// 导出服务器列表供前端使用
export const DOH_SERVERS = DOH_DNS_SERVERS;
